export const TENANT_BRANDING = {
  id: 'santaclara',
  name: 'Centro Médico Santa Clara',
  shortName: 'Santa Clara',
  siteName: 'Clara Hospital',
  alternateName: 'Santa Clara',
  tagline: 'Referente sanatorial de Canindeyú',
  positioning: 'Referente sanatorial de Canindeyú',
  vertical: 'healthcare',
  location: 'Nueva Esperanza, Canindeyú, Paraguay',
  phone: '0975 100 000',
  emergency: '0974 222 321',
  hours: {
    weekday: 'Lun-Vie 07:00-18:00',
    saturday: 'Sáb 07:00-12:00',
    emergency: 'Urgencias 24/7'
  },
  domains: [
    'turnos.clarahospital.com',
    'clarahospital.com'
  ]
};
